import React from 'react';

const ResultCard = ({ title, value, unit, highlight = false }) => {
  return (
    <div
      className={`p-6 rounded-xl border flex flex-col justify-center items-center text-center transition-all ${
        highlight
          ? 'bg-yellow-500/10 border-yellow-500/30'
          : 'bg-slate-950 border-slate-800'
      }`}
    >
      <p className="text-sm font-medium text-slate-400 mb-2">{title}</p>
      <div className="flex items-baseline gap-1">
        <span className={`text-4xl font-bold tracking-tight ${highlight ? 'text-yellow-500' : 'text-white'}`}>
          {value}
        </span>
        {unit && <span className="text-slate-400 font-medium">{unit}</span>}
      </div>
    </div>
  );
};

export default ResultCard;